// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueYouTubeEmbed from 'vue-youtube-embed'

import 'swiper/dist/css/swiper.css'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(VueAwesomeSwiper)
Vue.use(VueYouTubeEmbed)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js